import type { ItemFieldRow } from './item-field-reader';
import { readItemField } from './item-field-reader';
import { phpJsonString } from './php-json-values';
import { fromBaseClone, fromBaseUuid, FromBaseStageMissing } from './from-base-context';
import type { FromBaseRow as Row } from './from-base-context';
import { plainTextDecode } from './possessor-compile';

/** Native ability_choice label bake, before reference expansion. The reader
 * supplies provider-aware entries; names must come from held raw identities. */
export function constructInventoryDefinitionChoices(source: Row,
    entries: (row: ItemFieldRow, name: string) => ItemFieldRow,
    definition: (id: string) => ItemFieldRow | null): Row {
    const result = fromBaseClone(source);
    if (Object.prototype.hasOwnProperty.call(result, 'ability_choice_options')) return result;
    const choices = Object.values(entries(source, 'ability_choice'));
    if (!choices.length) return result;
    result.ability_choice_options = choices.flatMap(entry => {
        // Native accepts the legacy ability_id, bare item_id and [0] carrier,
        // but deliberately declines already-expanded bucketed shells.
        const carrier = entry && typeof entry === 'object' ? { items: entry } : null;
        const ability = readItemField(carrier, 'ability_id');
        const item = readItemField(carrier, 'item_id');
        const first = readItemField(carrier, '0');
        const id = typeof entry === 'string' ? entry : ability != null ? phpJsonString(ability)
            : typeof item === 'string' ? item
            : typeof first === 'string' ? first : '';
        if (!fromBaseUuid(id)) return [];
        const name = readItemField(definition(id), 'item_name');
        const decoded = typeof name === 'string' ? plainTextDecode(name) : null;
        if (decoded === null) throw new FromBaseStageMissing('definition-choice-name', id);
        return [{ item_id: id, item_name: decoded }];
    });
    return result;
}
